import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DnsIcon from '@material-ui/icons/Dns';
import RefreshIcon from '@material-ui/icons/Refresh'
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DeleteDialog from '../../components/DeleteDialog';
import MoreMenu from '../../components/utils/MoreMenu';
import Scenario from '../../api/Scenario';
import PermissionChecker from '../../components/permissions/PermissionChecker';


class ScenarioMoreMenu extends React.Component {
  static propTypes = {
    scenario: PropTypes.instanceOf(Scenario).isRequired,
    onUpdate: PropTypes.func,
  };

  static defaultProps = {
    onUpdate: null,
  };

  restartRun = async () => {
    const { scenario, onUpdate } = this.props
    await scenario.runModel();
    onUpdate(scenario)
  };

  render() {
    const { scenario, onUpdate } = this.props;
    return (
      <MoreMenu>
        <PermissionChecker permission="athena.view_scenario">
          {
            hasPermission =>
              <MenuItem
                component={Link}
                to={scenario.runReportUrl}
                disabled={!hasPermission}
              >
                <ListItemIcon><DnsIcon /></ListItemIcon>
                Run report
              </MenuItem>
          }
        </PermissionChecker>
        <PermissionChecker permission="athena.view_scenario">
          {
            hasPermission =>
              <MenuItem
                component={Link}
                onClick={()=> this.restartRun()}
                disabled={!hasPermission}
              >
                <ListItemIcon><RefreshIcon /></ListItemIcon>
                Restart
              </MenuItem>
          }
        </PermissionChecker>
        <PermissionChecker permission="athena.change_scenario">
          {
            hasPermission =>
              <MenuItem
                component={Link}
                to={scenario.editUrl}
                disabled={!hasPermission}
              >
                <ListItemIcon><EditIcon/></ListItemIcon>
                Edit
              </MenuItem>
          }
        </PermissionChecker>
        <PermissionChecker permission="athena.add_scenario">
          {
            hasPermission =>
              <MenuItem
                component={Link}
                to={scenario.copyUrl}
                disabled={!hasPermission}
              >
                <ListItemIcon><FileCopyIcon /></ListItemIcon>
                Copy
              </MenuItem>
          }
        </PermissionChecker>
        <PermissionChecker permission="athena.delete_scenario">
          {
            hasPermission =>
              <DeleteDialog
                instance={scenario}
                triggerFunc={handleOpen =>
                  <MenuItem
                    onClick={handleOpen}
                    disabled={!hasPermission}
                  >
                    <ListItemIcon><DeleteIcon/></ListItemIcon>
                    Delete
                  </MenuItem>
                }
                onUpdate={onUpdate}
              />
          }
        </PermissionChecker>
      </MoreMenu>
    );
  }
}


export default ScenarioMoreMenu;
